// Shared telemetry helpers. No app imports — safe at module load (like trace.js).

const NAME_RE = /^[a-z0-9_]{1,64}$/;

/**
 * Canonicalize a label to the server name allow-list (^[a-z0-9_]{1,64}$), or null.
 * Single source of truth for both funnel (track.js) and interaction (interactions.js)
 * names, so the server pattern is mirrored in exactly one place.
 * @param {*} raw
 * @param {{stripDigits?: boolean}} [opts] stripDigits also drops a trailing id-ish
 *   digit run (interaction cardinality guard, e.g. "row_12345" -> "row").
 * @returns {string|null}
 */
export function normalizeName(raw, { stripDigits = false } = {}) {
  if (typeof raw !== 'string') return null;
  let name = raw.toLowerCase().replace(/[^a-z0-9_]/g, '_');
  if (stripDigits) name = name.replace(/_?\d{4,}$/, '');
  name = name.slice(0, 64);
  return NAME_RE.test(name) ? name : null;
}

/**
 * crypto.randomUUID() with a non-secure-context fallback. randomUUID is undefined
 * in insecure contexts (HTTP, some embedded POS webviews); getRandomValues is not.
 * Single source for every telemetry id (client.js session id, track.js flow id).
 * @returns {string}
 */
export function safeUUID() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const a = new Uint8Array(16);
  crypto.getRandomValues(a);
  return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
}
